import { useAuth } from "@/contexts/AuthContext";
import { useFotosPerfil } from "@/hooks/useFotosPerfil";
import { usePerfilVista } from "@/hooks/usePerfilVista";

/**
 * Foto de perfil de quien se muestra en el encabezado y el pie del menú: la del usuario de la
 * sesión, o la de la persona impersonada con "Ver como". Para `AvatarPersona`.
 */
export function useFotoPerfilVista(): string | null {
  const { profile } = useAuth();
  const perfil = usePerfilVista();
  const fotos = useFotosPerfil({ emails: perfil.impersonando ? [perfil.email] : [] });
  return perfil.impersonando ? fotos.porEmail(perfil.email) : (profile?.foto_perfil_url ?? null);
}
